// src/localization/lang.en.js
export const lang = {
  header: {
    logoAlt: "Fast Caution Logo",
    home: "Home",
    create: "Create Deposit",
    pricing: "Pricing",
    contact: "Contact",
    language: "Language",
  },
  footer: "All rights reserved.",
  home: {
    title: "<0>Fast</0> Caution",
    subtitle: "The simple and secure solution for your short-term rental deposits*, using credit card.",
    ctaPrimary: "🚀 Create your deposit in 1 min",
    cardTitle: "How does it work?",
    step1: "Create and send a deposit request to the person of your choice, <0>it's free</0>!",
    step2: "The person pays their deposit by credit card, without being charged.",
    step3: "Damage? Collect the deposit partially or completely**.",
    cardFooter: "Simple, Basic",
    ctaSecondary: "🚀 Create your deposit in 1 min",
    disclaimer: "* Maximum of 7 days.\n** If you release the deposit, no fees apply, it's free! However, if you collect the deposit (fully or partially), bank transaction fees will apply (5% + €3 fixed)."
  },
  footer: "All rights reserved.",
  contact: {
    title: "Contact Form",
    subtitle: "Have an issue, doubt, or need information?",
    cardTitle: "Contact us",
    emailLabel: "Your email address",
    subjectLabel: "Subject",
    messageLabel: "Message",
    submitButton: "Send",
    loading: "Sending...",
    errorEmpty: "Please fill in all fields.",
    errorInvalidEmail: "Invalid email address.",
    success: "Your message has been sent successfully. We will reply soon."
  },
  pricing: {
    title: "Our Pricing",
    subtitle: "Clear and transparent prices.",
    cardTitle: "",
    creationLabel: "Creating a deposit",
    creationValue: "FREE",
    releaseLabel: "Release deposit",
    releaseValue: "FREE",
    collectionLabel: "Collecting deposit",
    collectionValue: "5% of collected amount + €3",
    footerText: "Simple, Basic 😍",
    cta: "🚀 Create my deposit"
  },
  checkout: {
    topImageAlt: "Fast Caution Logo",
    title: "",
    subtitle: "The simple and secure solution for your short-term rental deposits*, by credit card.",
    cardTitle: "Deposit",
    referenceLabel: "Reference:",
    requestedByLabel: "Requested by",
    cta: "Validate your deposit",
    loading: "Loading...",
    disclaimerStar: "* 7 days maximum",
    disclaimerText:
      "NO withdrawal will be made from your bank account (except for prepaid cards and neo-banks such as Revolut, N26, etc).\nThis is simply a hold on the indicated amount, similar to renting a car.\nOnly your credit card limit will be impacted."
  },
  checkoutSuccess: {
    title: "Deposit validated!",
    description: "Your pre-authorization was successfully validated.",
    homeButton: "Back to home"
  },
  createDepositSuccess: {
    title: "Your deposit request has been sent to the recipient 🚀",
    cardTitle: "Update my information",
    referenceLabel: "Reference:",
    prompt: "⚠️ Let your recipient know who you are",
    firstNameLabel: "My first name",
    lastNameLabel: "My last name",
    updateButton: "Update my information",
    success: "Successfully updated!",
    errorPrefix: "Error:",
    loading: "Loading..."
  },
  createDeposit: {
    title: "Create your deposit request",
    subtitle: "The recipient will receive the payment link by email. Once paid, you'll also be notified by email.",
    cardOwnerTitle: "You (or owner)",
    cardOwnerSubtitle: "The person requesting the deposit",
    cardClientTitle: "Recipient (or client)",
    cardClientSubtitle: "The person who will pay your deposit",
    ownerEmailLabel: "Your email address",
    depositAmountLabel: "Desired deposit amount",
    ownerClientEmailLabel: "Recipient's email address",
    submitButton: "Send request",
    errorTextfieldDeposit: "Amount must be between 20 and 2000",
    errorPrefix: "Error:",
    errorEmptyFields: "All fields must be filled.",
    errorInvalidEmail: "Email addresses must be valid.",
    errorSameEmail: "The recipient's email cannot be the same as yours.",
    errorResponse: "Error: invalid response.",
    captchaNotLoaded: "reCAPTCHA Enterprise is not loaded.",
    loading: "Processing..."
  },
  collectDeposit: {
    title: "Collect deposit",
    description: "Please enter the information to collect the deposit.",
    labelField: "Amount to collect",
    submitButton: "Collect",
    loading: "Processing collection...",
    error: "An error has occurred.",
    success: "The deposit has been successfully collected.",
    verificationTitle: "Verification required",
    verificationSubtitle: "To collect the deposit, you must first verify your identity.",
    verificationButton: "Verify my identity",
    pageErrorTitle: "Error",
    pageErrorSubtitle: "The required parameters are not provided in the URL",
  },
  releaseDeposit: {
    title: "Release deposit",
    description: "Confirm that you want to release the deposit.",
    submitButton: "Release",
    loading: "Releasing...",
    success: "The deposit has been successfully released.",
    error: "An error occurred while releasing the deposit.",
    pageErrorTitle: "Error",
    pageErrorSubtitle: "The required parameters are not provided in the URL",
  },
  notFound: {
    title: "Page not found",
    description: "Sorry, the page you're looking for does not exist.",
    homeButton: "Back to home"
  }
};

